<template>
  <v-sheet
    height="100%"
    class="overflow-hidden resume-sheet"
  >
    <v-row align="center" class="resume-mobile-header px-4">
      <v-col class="resume-mobile-header__col">
        <v-icon class="resume-mobile-header__back" @click="changePage">mdi-arrow-left</v-icon>
        <span class="resume-mobile-header__title">{{spaceSelected.name}}</span>
      </v-col>
    </v-row>

    <v-divider />

    <router-view></router-view>
    <v-row class="resume-mobile-content">

      <v-col class="resume-mobile-content__col">

          <v-col id="queues-container" cols="12" class="pa-2">
            <div class="resume-card">
              <QueuesList></QueuesList>
            </div>
          </v-col>

          <v-col id="stands-container" cols="12" class="pa-2">
            <div class="resume-card">
              <StandsList></StandsList>
            </div>
          </v-col>

          <v-col id="tickets-queue-container" cols="12" class="pa-2">
            <div class="resume-card">
              <widgetTicketsByQueue></widgetTicketsByQueue>
            </div>
          </v-col>

          <v-col id="tickets-space-container" cols="12" class="pa-2">
            <div class="resume-card">
              <widgetTotalTicketsBySpace></widgetTotalTicketsBySpace>
            </div>
          </v-col>

          <v-col id="contents-container" cols="12" class="pa-2">
            <div class="resume-card">
              <CreateContents></CreateContents>
            </div>
          </v-col>
    <!-- <v-row>

      <v-col>
        <v-row style="background-color:white; margin: 4%; border-radius:20px;">
          <v-col>
            <v-row>
              <p style="color:#777">Ubicación</p> 
            </v-row>
            <v-row>
              demo1
            </v-row>
          </v-col>
        </v-row>
      </v-col>

      <v-col>
        <v-row style="background-color:white; margin: 4%; border-radius:20px;">
          <v-col>
            <v-row>
             <p style="color:#777">Personas Atendidas</p> 
            </v-row>
            <v-row>
              demo2
            </v-row>
          </v-col>
        </v-row>
      </v-col>

      <v-col>
        <v-row style="background-color:white; margin: 4%; border-radius:20px;">
          <v-col>
            <v-row>
              <p style="color:#777">Afluencia de personas</p> 
            </v-row>
            <v-row>
              demo3
            </v-row>
          </v-col>
        </v-row>
      </v-col>

    </v-row> -->
    <!-- <v-row> -->

      <!-- <v-col>
        <v-row style="background-color:white; margin: 4%; 
          border-radius:20px;-webkit-box-shadow: 10px 10px 5px -2px rgba(0,0,0,0.14);
          -moz-box-shadow: 10px 10px 5px -2px rgba(0,0,0,0.14);
          box-shadow: 10px 10px 5px -2px rgba(0,0,0,0.14);">
          <v-col >
            <v-row style="border-bottom: 2px solid lightgrey;">
              <v-col style="padding-top: 0px;padding-bottom: 0px;padding-left: 10%;">
                <p style="color:#777; float:left;    font-size: 18px;">Colas</p> 
              </v-col>
              <v-col style="padding-top: 0px;padding-bottom: 0px;padding-right: 10%;">
                <p style="color:#777; cursor:pointer; float:right;    font-size: 15px;padding-top:3%" @click="goAllQueues">Ver todas</p>
              </v-col>
            </v-row>
            <v-row v-for="queues in allQueues" :key="queues.idQueue">

              <v-col style="padding-left:0px">
                <v-icon v-if="queues.type == 1" color="#679940">mdi-human-male-male</v-icon>
                <v-icon v-if="queues.type == 2" color="#679940">mdi-ticket-outline</v-icon>
                <v-icon v-if="queues.type == 3" color="#679940">mdi-ticket-confirmation</v-icon>
              </v-col>

              <v-col>
                <p style="float:left">{{queues.name}}</p>
              </v-col>

              <v-col>
                <p style="margin-bottom: -6px;float:left" v-if="queues.type == 1" >Fila</p>
                <p style="margin-bottom: -6px;float:left" v-if="queues.type == 2" >Tiquets</p>
                <p style="margin-bottom: -6px;float:left" v-if="queues.type == 3" >Multipuesto</p>
              </v-col>

            </v-row>
          </v-col>
        </v-row>
      </v-col> -->

      <!-- <v-col>
        <v-row style="background-color:white; margin: 4%; 
          border-radius:20px;-webkit-box-shadow: 10px 10px 5px -2px rgba(0,0,0,0.14);
          -moz-box-shadow: 10px 10px 5px -2px rgba(0,0,0,0.14);
          box-shadow: 10px 10px 5px -2px rgba(0,0,0,0.14);">
          <v-col >
            <v-row style="border-bottom: 2px solid lightgrey;">
              <v-col style="padding-top: 0px;padding-bottom: 0px;padding-left: 10%;">
                <p style="color:#777; float:left;    font-size: 18px;">Stands</p> 
              </v-col> -->
              <!-- <v-col>
                <p style="color:#777; float:right;">Ver todos</p> 
              </v-col>  -->
            <!-- </v-row>
            <v-row style="cursor:pointer;" v-for="resouce in allResouces" :key="resouce.idresource" @click="goResource(resouce)" >

              <v-col cols="4" style="padding-left:0px">
                <v-icon color="#679940">mdi-store</v-icon>
              </v-col>

              <v-col cols="8">
                <p style="float:left;">{{resouce.name}}</p>
              </v-col>  -->

               <!-- <v-col>
                <p >online</p>
              </v-col>  -->
            <!-- </v-row>
          </v-col>
        </v-row>
      </v-col> -->

    <!-- </v-row>

  </v-col>

  <v-col cols="3" style="background-color:lightgrey">
    <v-row style="background-color:white; margin: 4%; border-radius:20px;    
      height: 86%;-webkit-box-shadow: 10px 10px 5px -2px rgba(0,0,0,0.14);
      -moz-box-shadow: 10px 10px 5px -2px rgba(0,0,0,0.14);
      box-shadow: 10px 10px 5px -2px rgba(0,0,0,0.14);">
      
      <v-row style="width:100%">
          <p
            style="margin-bottom: 0px; padding-top: 8px;text-align: left; margin-left: 30px; font-size: 17px; color:#777; margin-right: 30px;"
          >Contenido</p>
      </v-row>

      <v-row style="margin-right: 0px; margin-left: 0px;margin-bottom: -10px;px;background-color:#f5f5f5">

        <v-col style="margin-right: 10px; margin-left: 10px;">

          <v-col v-bind:style="{backgroundColor: color3}" style="padding-top: 0px; background-color:#f5b70e;">
            <v-col>
            <p id="hour" style="float:right;font-size:11px">10:45 AM</p>
            </v-col>
            <v-row style="margin-left: 40px;">
            <v-col v-bind:style="{backgroundColor: color4}" style=" background-color:#f6c231; margin-top:10px;  border: 2px solid white;border-radius: 25px;">
              <p v-bind:style="{color: color5}" >HTML</p>
            </v-col>
            </v-row>
        
          </v-col>

        </v-col> 

      </v-row>

      <v-row style="margin-left:15px;margin-top:15px; padding-right: 50px; ">
        <v-text-field
          @input="hideAlertNameCont"
          label="Nombre Contenido"
          v-model="objQueueCont.name"
          dense
          required
          maxlength="40"
          :hint="objQueueCont.name ? `${objQueueCont.name.length}/40` : ''"
        ></v-text-field>
        <v-alert
          v-if="showAlertName"
          dense
          elevation="0"
          class="text-left"
          style="font-size: 12px; color:red; margin-left:-15px; margin-top:-12px"
        >Necesita un nombre el Contenido</v-alert>
      </v-row>

      <v-row>
        <v-col style="padding-top: 0px;padding-bottom: 0px;">
          <p style="font-size:11px;margin-bottom:5px;">Color Primario</p>
        </v-col>
        <v-col style="padding-top: 0px;padding-bottom: 0px;">
          <p style="float:left;font-size:11px;margin-bottom:5px;">Color Secundario</p>
        </v-col>
        <v-col style="padding-top: 0px;padding-bottom: 0px;">
          <p style="float:left;font-size:11px;margin-bottom:5px;">Color Texto</p>
        </v-col>
      </v-row>

      <v-row>

        <v-col cols="1" style="padding: 0px;min-width:fit-content; padding-bottom: 0px; padding-top: 0px;">
          <div style="text-align:left; margin-left: 15px;">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                   x-small
                  height="27px"
                  width="27px"
                  :color="color3"
                  dark
                  v-on="on"
                >
                </v-btn>
              </template>
              <v-color-picker
              value="#7417BE"
              v-model="color3"
              hide-canvas 
              hide-inputs 
              show-swatches
              class="mx-auto"
            ></v-color-picker>
            </v-menu>
          </div>
        </v-col>

        <v-col cols="1" style="padding: 0px;min-width:fit-content; padding-bottom: 0px; padding-top: 0px;">
          <p style="float: left;font-size:12px">{{color3}}</p>
        </v-col>

        <v-col cols="1" style="padding: 0px;min-width:fit-content; padding-bottom: 0px; padding-top: 0px;">
          <div style="text-align:left; margin-left: 15px;">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                   x-small
                  height="27px"
                  width="27px"
                  :color="color4"
                  dark
                  v-on="on"
                >
                </v-btn>
              </template>
              <v-color-picker
              value="#7417BE"
              v-model="color4"
              hide-canvas 
              hide-inputs 
              show-swatches
              class="mx-auto"
            ></v-color-picker>
            </v-menu>
          </div>
        </v-col>

        <v-col cols="1" style="padding: 0px; min-width:fit-content; padding-bottom: 0px; padding-top: 0px;">
          <p style="float: left;font-size:12px">{{color4}}</p>
        </v-col>

        <v-col cols="1" style="padding: 0px;min-width:fit-content; padding-bottom: 0px; padding-top: 0px;">
          <div style="text-align:left; margin-left: 15px;">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  x-small
                  height="27px"
                  width="27px"
                  :color="color5"
                  dark
                  v-on="on"
                >
                </v-btn>
              </template>
              <v-color-picker
              value="#7417BE"
              v-model="color5"
              hide-canvas 
              hide-inputs 
              show-swatches
              class="mx-auto"
            ></v-color-picker>
            </v-menu>
          </div>
        </v-col>

        <v-col cols="1" style="padding: 0px;min-width:fit-content; padding-bottom: 0px; padding-top: 0px;">
          <p style="float: left;font-size:12px">{{color5}}</p>
        </v-col>
      </v-row>

      <v-row style="margin-left:5px; padding-right:50px;">
        <v-col style="padding-top: 0px;padding-bottom: 0px;">
          <v-text-field
            @input="hideAlertWidthCont"
            label="Width"
            v-model="objQueueCont.width"
            dense
            required
            suffix="px"
            style="padding-top: 0px;padding-bottom: 0px;"
          ></v-text-field>
          <v-alert
            v-if="showAlertWidth"
            dense
            elevation="0"
            class="text-left"
            style="font-size: 12px; color:red; margin-left:-15px; margin-top:-12px"
          >Necesita un ancho el contenido</v-alert>
        </v-col>

        <v-col style=" margin-left:5px;padding-top: 0px;padding-bottom: 0px;">
          <v-text-field
            @input="hideAlertHeightCont"
            label="Height"
            v-model="objQueueCont.height"
            dense
            required
            suffix="px"
            style="padding-top: 0px;padding-bottom: 0px;"
          ></v-text-field>
          <v-alert
            v-if="showAlertHeight"
            dense
            elevation="0"
            class="text-left"
            style="font-size: 12px; color:red; margin-left:-15px; margin-top:-12px"
          >Necesita un alto el contenido</v-alert>
        </v-col>
      </v-row>
                
      <v-row style="    margin-left: 15px; padding-right: 50px;">
        <v-file-input v-model="objQueueCont.miarchivo" chips truncate-length="25" label="Añade tu logo" style="padding-top: 0px;"></v-file-input>
      </v-row>

      <v-row style="    margin-left: 15px; padding-right: 50px;">
        <v-checkbox style="margin-top: 5px;" @click="setClock" v-model="checkbox" :label="`Clock`"></v-checkbox>
      </v-row>

      <v-row>
                <v-btn
        @click="sendHtml(objQueueCont)"
        color="#679940"
        dark
        rounded
        depressed
        small
        min-width="100"
        style="margin-left:35px"
      >Crear</v-btn>
      </v-row>
    </v-row>--> 
  </v-col> 

</v-row>


  </v-sheet>
</template>

<script>
import axios from "axios";
import { mapState, mapActions, mapMutations } from "vuex";
import router from "vue-router";
import RightMenuAddNewQueue from "@/components/RightMenuAddNewQueue.vue";
import RightMenuEditQueue from "@/components/RightMenuEditQueue.vue";
import CreateContents from "@/components/CreateContents.vue";
import QueuesList from "@/components/QueuesList.vue";
import StandsList from "@/components/StandsList.vue";
import widgetTicketsByQueue from "@/components/widgetTicketsByQueue.vue";
import widgetTotalTicketsBySpace from "@/components/widgetTotalTicketsBySpace.vue";


export default {
  name: "Queues",
  components: {
    RightMenuAddNewQueue,
    RightMenuEditQueue,
    CreateContents,
    QueuesList,
    StandsList,
    widgetTicketsByQueue,
    widgetTotalTicketsBySpace,
  },
  data() {
    return {
          checkbox: true,
          showAlertName: false,
    showAlertWidth: false,
    showAlertHeight: false,
      color3: '#f5b70e',
        color4: '#f6c231',
        color5: '#FFFFFFFF',
      deleteDialog: false,
      search: "",
      skeleton: true,
      selected: [],
      arrProposalData: [],     
    };
  },
  computed: {
        ...mapState("app", ["actualProject"]),

    ...mapState("queues", ["spaceSelected","allResouces","objQueueCont","allQueues","RightMenuAddNewQueue","showRightMenu","allSpaces","RightMenuEditQueue"]),

    headers() {
      return [
        { text: "", value: "icon", },
        { text: "Nombre", value: "name", align: "start", },
        { text: "Tipo", value: "type", },
        { text: "Sitio", value: "spaceName", },
        { text: "Stands", value: "numberResources", },
        { text: "", value: "Actions",  },
      ];
    },

  },
  methods: {
    ...mapMutations("queues", ["setActualSpaceMutation","spaceActions","openRightMenuMutation","closeRightMenuMutation"]),
    ...mapActions("queues", ["getTicketStore","sendHtmlSpaceStore","getAllQueues","getAllSpaces","getAllResouces","editQueueStore","showRightMenuProposalStore","hideRightMenuProposalStore","rightMenuTrueNewDeviceTableStore","rightMenuTrueNewDeviceTableStore2","deleteMultipleQueues","deleteOneQueueStore","getTicketsInfoByQueueAndSpace","getTicketsInfoBySpace"]),
    goToCampaignAs(role) {
      this.viewAsClient = true;
    },
    async goResource(resource){

      this.spaceActions(resource);      
      await this.getTicketStore(resource.idResource);
      this.$router.push({
        name: "GeneralStandTurnMobile",
        params: { idSpace: resource }
      });
    },

    setClock(){
      let element = document.getElementById("hour");
      
      if(this.checkbox == false){
        element.style.display='none';     
      }else{
        element.style.display='';     
      }
    },

    hideAlertNameCont() {
      if (this.objQueueCont.name != "") {
        this.showAlertName = false;
      }
    },
    hideAlertWidthCont() {
      if (this.objQueueCont.width != "") {
        this.showAlertWidth = false;
      }
    },
    hideAlertHeightCont() {
      if (this.objQueueCont.height != "") {
        this.showAlertHeight = false;
      }
    },

    changePage() {
        this.$router.push({
            name: "ListSpacesMobile",
        });
        this.closeRightMenuMutation();
    },
    goAllQueues(){
      this.$router.push({
        name: "QueuesMobile",
      });
    },
    sendHtml(cont){

      if(cont.name == "" ||cont.name == undefined){
        this.showAlertName = true;
      } 
      if(cont.width == undefined){
        this.showAlertWidth = true;
       }
      if(cont.height == undefined){
        this.showAlertHeight = true;
      }

      if (this.showAlertName == false && this.showAlertWidth == false && this.showAlertHeight == false ) {
        cont.contentColor = this.color3
        cont.contentColor2 = this.color4
        cont.contentColor3 = this.color5
        if(this.checkbox == true){
          cont.clock_ = "on"
        }else{
          cont.clock_ = "off"
        }
        cont.project = this.actualProject.id
        let idProject = this.actualProject.id
        let idSpace = this.spaceSelected.idSpace
        let dataInfo = [cont, idProject,idSpace]
        
        this.sendHtmlSpaceStore(dataInfo);
        // this.objQueueCont = []
      }
    }
  },

  async created() {  

    let idProject = "";
    
    if (this.actualProject == undefined) {
      idProject = this.firstProject.id;
    } else {
      idProject = this.actualProject.id;
    }   
    
    await this.getAllSpaces(idProject);  
    await this.getAllResouces(idProject);   
    await this.getAllQueues(idProject);
    await this.getTicketsInfoByQueueAndSpace(this.spaceSelected.idSpace);
    await this.getTicketsInfoBySpace(this.spaceSelected.idSpace);

  },
  destroyed() {},
};
</script>

<style scoped>
.resume-sheet {
  position: relative;
  margin-top: 0;
  border-radius: 0;
}
.resume-mobile-header {
  background-color: #fff;
  min-height: 56px;
}
.resume-mobile-header__col {
  display: flex;
  align-items: center;
}
.resume-mobile-header__back {
  cursor: pointer;
}
.resume-mobile-header__title {
  margin-left: 12px;
  font-size: 18px;
  font-weight: 300;
  color: #777;
  white-space: nowrap;
}
.resume-mobile-content {
  height: 100%;
  max-height: calc(100vh - 125px);
  overflow: auto;
  position: relative;
  margin-top: 0;
  border-radius: 0;
  background-color: #f5f5f5;
}
.resume-mobile-content__col {
  background-color: #f5f5f5;
  padding: 12px;
}
.resume-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 14px;
  overflow: hidden;
}
a {
  text-decoration: none;
}
>>> .v-data-table__wrapper {
  height: auto;
  overflow: visible;
}
>>> th {
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/ResumeSpaceMobile.vue